import { AxiosError } from "axios";
import { useQuery } from "react-query";
import { AskQnAResponse } from "../types";
import axiosClient from "../utils/axiosClient";
import qs from "query-string";

export const useAskQuestion = (
  question: string,
  executionId: number,
  gptQna?: boolean,
  callFromOpenLLM?:boolean,
) => {
  return useQuery<any, AxiosError<any>, AskQnAResponse>(
    ["ask", executionId, question, gptQna, callFromOpenLLM],
    () => {
      const qp: Record<string, any> = {
        question,
        executionId,
        gptQna,
        callFromOpenLLM
      };

      return axiosClient
        .get<AskQnAResponse>(`/execution/qna?${qs.stringify(qp)}`, {
          timeout: 5 * 60 * 1000, // 5 mins timeout
        })
        .then(({ data }) => data);
    },
    {
      enabled: false,
      staleTime: Infinity,
      cacheTime: Infinity,
      retry: false,
    }
  );
};
